import Profiles from '../ProfileCards'
import AbilityCards from '../AbilityCards'

const useProfileTabs = () => {

    const tabs = [
        {
            label: "ביצועים",
            component: AbilityCards,
            tooltip: "חלוקת תלמידים לפי יכולות בתחומי הביצוע השונים"
        },
        {
            label: "פרופילים",
            component: Profiles,
            tooltip: "חלוקת תלמידים לפי פרופילים של קצב ודיוק"
        }
    ]

    return tabs
}

export default useProfileTabs;